import { getAppsRoute, getRouteLogin } from '@/shared/const/router.const.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useLayoutEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Toaster } from '@/shared/ui/shadcn/ui/sonner';
import { useAuth } from '@/shared/hooks/useAuth/useAuth';
import { useBoundStore } from '@/shared/store';
import { apiSubscribe } from '@/shared/api/api';

const queryClient = new QueryClient();

useBoundStore.subscribe((state) => {
  apiSubscribe(state);
});

export const PublicProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated } = useAuth();

  const { pathname } = location;

  const isLoginPage = pathname === getRouteLogin();

  useLayoutEffect(() => {
    // Redirect to dashboard page if authenticated
    if (isAuthenticated && isLoginPage) {
      navigate(getAppsRoute());
    }
  }, [isLoginPage, navigate, isAuthenticated]);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
      <Toaster />
    </QueryClientProvider>
  );
};
